import MargettsDomHelper from './modules/dom';

/*******
 * PWA *
 *******/

// Detect which display mode we're running in
const getAppDisplayMode = () => {
    if (document.referrer.startsWith('android-app://')) {
        return 'twa';
    }

    const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
    const isMinimalUi = window.matchMedia('(display-mode: minimal-ui)').matches;

    if (('standalone' in navigator && navigator.standalone) || isStandalone || isMinimalUi) {
        return 'pwa';
    }

    return 'browser';
}

// Detect if in app mode
const isInAppMode = () => {
    return getAppDisplayMode() === 'pwa';
};

// Set up app installation buttons
const appInstallationButtons = document.getElementsByClassName('js-app-install');

const showAppInstallationButtons = () => {
    if (isInAppMode()) {
        removeNonAppLinks();
        return;
    }

    [].forEach.call(appInstallationButtons, appInstallationButton => {
        MargettsDomHelper.showElement(appInstallationButton);

        appInstallationButton.addEventListener('click', event => {
            return showAppInstallPrompt();
        });
    });
}

const hideAppInstallationButtons = () => {
    [].forEach.call(appInstallationButtons, appInstallationButton => {
        MargettsDomHelper.hideElement(appInstallationButton);
    });
};

const removeNonAppLinks = () => {
    document.querySelectorAll('.hide-in-app').forEach(link => link.remove());
};

// Register service worker
window.addEventListener('load', () => {
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.register('/service-worker.js')
            .then(registration => {
                // console.log('Service worker registered: ', registration);

                registration.addEventListener('updatefound', event => {
                    // console.log('Service worker found: ', event.target.installing);
                });
            }).catch(error => {
                // console.log('Could not register service worker', error);
            });

        navigator.serviceWorker.ready.then(registration => {
            // console.log('Service worker is active: ', registration.active);
            // console.log('This service worker is in control: ', navigator.serviceWorker.controller);
        });

        navigator.serviceWorker.addEventListener('controllerchange', () => {
            // console.log('Controlling service worker has changed.');
        })
    }
});

let deferredPrompt;

if ('onbeforeinstallprompt' in window) {
    showAppInstallationButtons();

    // Catch installation prompt
    window.addEventListener('beforeinstallprompt', event => {
        event.preventDefault();
        deferredPrompt = event;
    });
}

// Fire installation prompt
const showAppInstallPrompt = async () => {
    if (deferredPrompt) {
        deferredPrompt.prompt();
        const {outcome} = await deferredPrompt.userChoice;
        deferredPrompt = null;

        // Trigger installation prompt server event
        axios.post('/actions/dismissAppInstallPrompt', {
            outcome: outcome
        }).then(response => {
            hideAppInstallationButtons();
        });
    } else {
        alert('Sorry, your browser doesn\'t support installing this app. Are you in incognito mode?');
    }
};

if ('onappinstalled' in window) {
    // Intercept installation event
    window.addEventListener('appinstalled', () => {
        hideAppInstallationButtons();
        deferredPrompt = null;
    });
}
